import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  root: {
    '& .MuiAutocomplete-inputRoot': {
      padding: '0 !important'
    }
  }
}));